import { render, staticRenderFns } from "./Referees.vue?vue&type=template&id=70850ec6"
import script from "./Referees.vue?vue&type=script&lang=js"
export * from "./Referees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports